module.exports = __webpack_public_path__ + "c01845e481b1fdc4902d231018551793.png";